import React from "react";
import { cn } from "@/lib/utils";

interface DialogBodyProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * DialogBody component for scrollable content areas in dialogs.
 * Includes fade gradients at top and bottom to indicate scrollable content.
 */
export const DialogBody: React.FC<DialogBodyProps> = ({
  children,
  className,
}) => {
  return (
    <div className={cn("overflow-y-auto flex-1 px-6", className)}>
      {/* Top fade gradient - appears when content is scrolled */}
      <div className="pointer-events-none sticky top-0 left-0 right-0 z-10 h-8 -mx-6 mb-[-2rem] bg-gradient-to-b from-card to-transparent" />
      <div className="space-y-4 pt-6 pb-6">{children}</div>
      {/* Bottom fade gradient - appears when there's more content below */}
      <div className="pointer-events-none sticky bottom-0 left-0 right-0 z-10 h-8 -mx-6 mt-[-2rem] bg-gradient-to-t from-card to-transparent" />
    </div>
  );
};
